import store from 'state/store';
import { submit } from './actions';

export default {
    submit: data => {
        return store.dispatch(submit(data));
    },
};
